import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Button,
  message,
  Divider,
  Table,
  Input,
  Tooltip,
  Form,
  Modal,
  Select,
  Space,
  Progress,
  Dropdown,
} from "antd";
import {
  EditOutlined,
  SearchOutlined,
  PlusOutlined,
  DeleteOutlined,
  UnorderedListOutlined,
  FileDoneOutlined,
  CheckCircleOutlined,
  TeamOutlined,
  BarChartOutlined,
} from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import http from "../../../services/http";
const { Text } = Typography;

export const AvaliacoesFormularios = () => {
  const navigate = useNavigate();
  const { id_avaliacao } = useParams();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();

  // ID ALTERAÇÃO
  const [search, setSearch] = useState("");

  // FORMULÁRIOS
  const [formularios, setFormularios] = useState([]);
  const [avaliacao, setAvaliacao] = useState({});

  useEffect(() => {
    if (id_avaliacao) {
      carregarAvaliacao(id_avaliacao);
      listarVinculoFormularios(id_avaliacao);
      listarFormularios(id_avaliacao);
    }
  }, [id_avaliacao]);

  // CARREGAR AVALIAÇÃO
  const carregarAvaliacao = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/avaliacoes/carregar/${id}`, []);
    if (api.statusCode === 200) {
      if (api?.response?.data) {
        setAvaliacao(api.response.data);
      }
    } else {
      message.error(api.response.message);
      navigate("/avaliacoes/gestao");
    }
    setLoading(false);
  };

  // LISTAR FORMULÁRIOS
  const listarFormularios = async (id_avaliacao) => {
    setLoading(true);
    const api = await http("get", `v1/avaliacoes_formularios/listar_ativos/${id_avaliacao}`, []);
    if (api.statusCode === 200) {
      let array_formularios = [];
      if (api.response.data) {
        api?.response?.data?.forEach((e) => {
          array_formularios.push({ label: `${e.cargos_estrutura} - ${e.descricao}`, value: e.id });
        });
      }
      setFormularios(array_formularios);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR
  const listarVinculoFormularios = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/avaliacoes_vinculo_formularios/listar/${id}`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CADASTRAR
  const cadastrarVinculoFormulario = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/avaliacoes_vinculo_formularios/adicionar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro cadastrado com sucesso!");
      setShowModal(false);
      resetForm();
      listarVinculoFormularios(id_avaliacao);
      listarFormularios(id_avaliacao);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // DELETAR
  const deletarVinculoFormulario = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/avaliacoes_vinculo_formularios/deletar`, { id: id });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      listarVinculoFormularios(id_avaliacao);
      listarFormularios(id_avaliacao);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RESET FORM
  const resetForm = () => {
    form.resetFields();
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Classificação",
      dataIndex: "classificacao",
      sorter: (a, b) => a.classificacao?.localeCompare(b.classificacao),
    },
    {
      title: "Formulário",
      dataIndex: "formulario",
      sorter: (a, b) => a.formulario?.localeCompare(b.formulario),
    },
    {
      key: "realizados",
      title: "Realizados",
      render: (_, e) => (
        <Text>
          {e.total_realizados} / {e.total_formularios}
        </Text>
      ),
    },
    {
      key: "progresso",
      title: "Progresso",
      render: (_, e) => (
        <Progress
          size="small"
          percent={(e.total_formularios > 0 ? (e.total_realizados * 100) / e.total_formularios : 0).toFixed(2)}
          steps={10}
          strokeColor={"#60b565"}
        />
      ),
    },
    {
      title: "Ações",
      width: 150,
      render: (_, e) => {
        const items = [
          {
            key: "1",
            label: "Pendências Avaliados",
            icon: <BarChartOutlined />,
            onClick: () => navigate(`/avaliacoes/gestao/formularios/${id_avaliacao}/pendencias/${e.id}`),
          },
          {
            key: "2",
            label: "Pendências Avaliadores",
            icon: <BarChartOutlined />,
            onClick: () => navigate(`/avaliacoes/gestao/formularios/${id_avaliacao}/pendencias-avaliadores/${e.id}`),
          },
        ];

        return (
          <Space.Compact>
            <Tooltip title="Editar Cargos">
              <Button
                loading={loading}
                onClick={() => navigate(`/avaliacoes/gestao/formularios/${id_avaliacao}/cargos/${e.id}`)}
                icon={<CheckCircleOutlined />}
              />
            </Tooltip>

            {/* <Tooltip title="Colaboradores">
							<Button
								loading={loading}
								onClick={() => navigate(`/avaliacoes/gestao/formularios/${id_avaliacao}/colaboradores/${e.id}`)}
								icon={<TeamOutlined />}
							/>
						</Tooltip> */}

            <Dropdown menu={{ items }}>
              <Button loading={loading} icon={<BarChartOutlined />} />
            </Dropdown>

            {avaliacao?.status_formulario === 0 && (
              <Tooltip title="Excluir">
                <Button
                  loading={loading}
                  icon={<DeleteOutlined />}
                  onClick={() => {
                    modal.confirm({
                      title: "Deseja deletar este registro?",
                      okText: "Sim",
                      cancelText: "Cancelar",
                      onOk() {
                        deletarVinculoFormulario(e.id);
                      },
                    });
                  }}
                />
              </Tooltip>
            )}
          </Space.Compact>
        );
      },
      dataIndex: "acoes",
    },
  ];

  // SUBMIT FORM
  const onSubmit = (formulario) => {
    formulario.id_cad_avaliacoes = id_avaliacao;

    cadastrarVinculoFormulario(formulario);
  };

  // PESQUISAR
  const handleFilter = (pesquisar) => {
    let filteredData = dados?.filter(
      (val) =>
        val.classificacao?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.formulario?.toLowerCase().includes(pesquisar.toLowerCase())
    );

    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search) : [];

  // FORMULÁRIO
  const modalFormulario = () => {
    return (
      <Modal
        title={
          <Text style={{ fontSize: 20 }}>
            <EditOutlined /> Vincular Formulário
          </Text>
        }
        open={showModal}
        onOk={() => form.submit()}
        okText="Salvar"
        width={800}
        okButtonProps={{ size: "large", loading: loading }}
        cancelButtonProps={{ size: "large", loading: loading }}
        onCancel={() => {
          setShowModal(false);
          resetForm();
        }}>
        <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" span={24}>
              <Form.Item
                name="id_avaliacoes_cad_formularios"
                label="Formulário"
                rules={[{ required: true, message: "Selecione o formulário!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione o formulário"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={formularios}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalFormulario()}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Avaliações" onClickBack={() => navigate("/avaliacoes/gestao")} />
            <HeaderTitle
              title="Avaliações Vínculo Formulários"
              subtitle={
                <Text italic>
                  <FileDoneOutlined /> {avaliacao?.descricao ?? ""}
                </Text>
              }
              icon={<UnorderedListOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space wrap>
                <Input
                  size="middle"
                  maxLength={100}
                  prefix={<SearchOutlined />}
                  className="input"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Pesquisar..."
                  allowClear
                />

                {avaliacao?.status_formulario === 0 && (
                  <Tooltip title="Adicionar Registro">
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={() => {
                        setShowModal(true);
                        resetForm();
                      }}
                      loading={loading}>
                      Novo
                    </Button>
                  </Tooltip>
                )}
              </Space>

              <Divider />

              <Table
                loading={loading}
                rowKey="id"
                scroll={{ x: 700 }}
                columns={columns}
                dataSource={dadosFilter}
                size="small"
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
